var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"agentEntrustTab"}},[_c('b-tabs',{staticClass:"tab-header",attrs:{"pills":"","card":""},model:{value:(_vm.tabIndexHeader),callback:function ($$v) {_vm.tabIndexHeader=$$v},expression:"tabIndexHeader"}},[_c('b-tab',{attrs:{"title":_vm.$t('entrustedList.tabTxt15')}},[_c('EntrustedList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }